export default __webpack_public_path__ + "static/media/Laffayette_Comic_Pro.94b9a328.ttf";